// import {createRoot} from 'react-dom/client'
// // Axios
// import axios from 'axios'
// import {Chart, registerables} from 'chart.js'
// import {QueryClient, QueryClientProvider} from 'react-query'
// import {ReactQueryDevtools} from 'react-query/devtools'
// // Apps
// import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
// /**
//  * TIP: Replace this style import with rtl styles to enable rtl mode
//  *
//  * import './_metronic/assets/css/style.rtl.css'
//  **/
// import './_metronic/assets/sass/style.scss'
// import './_metronic/assets/sass/plugins.scss'
// import './_metronic/assets/sass/style.react.scss'
// import './_metronic/ops/sass/helper.scss'
// import './_metronic/ops/sass/template-override.scss'
// import {AppRoutes} from './app/routing/AppRoutes'
// import {AuthProvider, setupAxios} from './app/modules/auth'
// /**
//  * Creates `axios-mock-adapter` instance for provided `axios` instance, add
//  * basic Metronic mocks and returns it.
//  *
//  * @see https://github.com/ctimmerm/axios-mock-adapter
//  */
// /**
//  * Inject Metronic interceptors for axios.
//  *
//  * @see https://github.com/axios/axios#interceptors
//  */
// setupAxios(axios)
// Chart.register(...registerables)

// const queryClient = new QueryClient()
// const container = document.getElementById('root')
// if (container) {
//   createRoot(container).render(
//     <QueryClientProvider client={queryClient}>
//       <MetronicI18nProvider>
//         <AuthProvider>
//           <AppRoutes />
//         </AuthProvider>
//       </MetronicI18nProvider>
//       <ReactQueryDevtools initialIsOpen={false} />
//     </QueryClientProvider>
//   )
// }

import React from 'react'
import {createRoot} from 'react-dom/client'
// Axios
// import axios from 'axios'
// import { Chart, registerables } from 'chart.js'
import {QueryClient, QueryCache, QueryClientProvider} from '@tanstack/react-query'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import 'antd/dist/reset.css'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/ops/sass/helper.scss'
import './_metronic/ops/sass/template-override.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider} from './app/modules/auth'

/*
 * Service Workers
 */
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'
// import reportWebVitals from './reportWebVitals'
import {MarvelToast} from './app/helper/MarvelToast'
import {IsApiResponseError, IsErrorResponse} from 'app/core/_core'

// setupAxios(axios)
// Chart.register(...registerables)

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      /**
       * query.meta.errorMessage is custom error message specified per react query call. if specified"
       * if specified, then show this error message instead of generic error message
       * more details https://tkdodo.eu/blog/breaking-react-querys-api-on-purpose
       * */
      // const customErrorMessage = query.meta?.errorMessage as string

      var isNotFound: boolean = false
      if (IsApiResponseError(error)) {
        if (error?.error?.includes('not found')) isNotFound = true
      } else if (IsErrorResponse(error)) {
        if (error?.message?.includes('not found')) isNotFound = true
      }

      if (isNotFound) {
        MarvelToast.error(`Data tidak ditemukan.`)
      } else {
        // MarvelToast.error('Terjadi kesalahan pada saat pengajuan permintaan')
      }
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5,
    },
  },
})

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </MetronicI18nProvider>
    </QueryClientProvider>
  )
}

// serviceWorkerRegistration.unregister()
// reportWebVitals()
